import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toast"
export default class extends Controller {
  static values = { duration: Number }
  
  connect() {
    // Auto-remove toast after specified duration (default 3000ms)
    const duration = this.durationValue || 3000
    
    this.timeout = setTimeout(() => {
      this.remove()
    }, duration)
  }
  
  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }
  
  close() {
    this.remove()
  }
  
  remove() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    
    // Add fade out animation
    this.element.style.opacity = '0'
    this.element.style.transform = 'translateY(-20px)'
    this.element.style.transition = 'all 0.3s ease-out'
    
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}